import React from 'react';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import SideMenu from '../publicComponents/sideMenu';
import { getBayansByCategory, getCategoryList } from '../actions/actions';
import '../App.css';
import LatestBayanContent from './latestBayanContent';
import OtherBayansContent from './otherBayansContent';

class BayansContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: '',
      bayansCount: 0,
      isContentLoading: true,
      bayansList: [],
    };
  }
  componentDidMount = () => {
    this.getBayansListWithCategory('All');
  };

  getBayansListWithCategory = param => {
    let bayansList = [];
    let categoryList = [];

    this.props.getCategoryList().then(() => {
      const { bayans } = this.props;
      categoryList = bayans;
      this.props.getBayansByCategory(`${param}`).then(() => {
        const { bayans } = this.props;
        let bayansListUpdated = [];
        bayansList = bayans;
        bayansList.map((value, key) => {
          let obj = categoryList.find(obj => obj.id === value.category);
          value.category = obj ? obj.name : 'All';
          bayansListUpdated.push({
            ...value,
          });
        });
        this.setState({
          bayansCount: bayansListUpdated.length,
          isContentLoading: false,
          bayansList: bayansListUpdated,
        });
      });
    });
  };
  handleCategory = category => {
    this.setState({
      isContentLoading: true,
    });
    this.getBayansListWithCategory(`${category}`);
  };

  render() {
    const { bayans } = this.props;
    const { bayansCount, isContentLoading, bayansList } = this.state;

    return (
      <div>
        <Spin tip='' spinning={isContentLoading}>
          <article className='article-padd-half bg-gray'>
            <div className='container'>
              <div className='row'>
                <SideMenu
                  getSelectedCategory={this.handleCategory}
                  category={'bayans'}
                />
                <div className='col-md-9'>
                  <div className='body-content-wrap'>
                    <h3>Bayaans ({bayansCount}) </h3>
                    {isContentLoading === false && (
                      <LatestBayanContent
                        bayansCount={bayansCount}
                        bayans={bayansList}
                      />
                    )}
                    {isContentLoading === false && (
                      <OtherBayansContent
                        bayansCount={bayansCount}
                        bayans={bayansList}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </article>
        </Spin>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  const { homeData } = state;
  if (homeData)
    return {
      bayans: homeData,
    };
  return {
    bayans: null,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getBayansByCategory: category => dispatch(getBayansByCategory(category)),
    getCategoryList: () => dispatch(getCategoryList()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BayansContent);
